module.exports = {
	"id": "TM",
	"name": "Turkmenistan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.00436,
			"6": null,
			"7": null,
			"8": 0.05014,
			"9": 0.08502,
			"10": 0.00218,
			"11": 0.1199,
			"12": 0.04578,
			"13": 0.04142,
			"14": 0.0109,
			"15": 0.02834,
			"16": 0.09156,
			"17": 0.03706,
			"18": 0.00218,
			"19": 0.00436,
			"20": 0.01962,
			"21": 0.01308,
			"22": 0.0109,
			"23": 0.00654,
			"24": 0.00654,
			"25": null,
			"26": 0.0109,
			"27": 0.0436,
			"28": 0.05232,
			"29": 0.00872,
			"30": 0.01526,
			"31": 0.03052,
			"32": null,
			"33": 0.01744,
			"34": 0.00654,
			"35": 0.00872,
			"36": null,
			"37": 0.01308,
			"38": 0.14388,
			"39": 0.0763,
			"40": 0.00872,
			"41": 0.0218,
			"42": 0.02834,
			"43": 0.05886,
			"44": 0.01526,
			"45": 0.24198,
			"46": 0.01526,
			"47": 0.0436,
			"48": 0.08284,
			"49": 0.45998,
			"50": 0.06758,
			"51": 0.17658,
			"52": 0.21582,
			"53": 7.82838,
			"54": 1.65244,
			"55": 0.01962,
			"56": 0.00654,
			"57": null
		},
		"firefox": {
			"2": 0.03706,
			"3": 0.00654,
			"4": 0.00654,
			"5": 0.00872,
			"6": 0.00436,
			"7": null,
			"8": null,
			"9": 0.00872,
			"10": 0.00654,
			"11": null,
			"12": 0.00436,
			"13": 0.00872,
			"14": 0.00872,
			"15": null,
			"16": 0.00436,
			"17": 0.01308,
			"18": 0.00872,
			"19": null,
			"20": 0.00436,
			"21": 0.05014,
			"22": 0.00654,
			"23": 0.01744,
			"24": 0.0109,
			"25": 0.0109,
			"26": 0.02398,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.0109,
			"31": 0.00654,
			"32": 0.00654,
			"33": 0.00872,
			"34": 0.02616,
			"35": 0.00872,
			"36": 0.01308,
			"37": 0.00654,
			"38": 0.01962,
			"39": 0.00436,
			"40": 0.00872,
			"41": 0.0218,
			"42": 0.0327,
			"43": 0.06322,
			"44": 0.00654,
			"45": 0.0436,
			"46": 0.01526,
			"47": 0.21364,
			"48": 0.09156,
			"49": 0.54064,
			"50": 0.0109,
			"51": 0.00218,
			"52": 0.01744,
			"3.5": 0.0109,
			"3.6": 0.10246
		},
		"opera": {
			"9": null,
			"11": 0.00436,
			"12": 0.02398,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01962,
			"19": 0.01308,
			"20": 0.01308,
			"21": null,
			"22": null,
			"23": 0.01308,
			"24": null,
			"25": null,
			"26": 0.01744,
			"27": 0.02616,
			"28": null,
			"29": 0.05232,
			"30": 0.00654,
			"31": null,
			"32": 0.00872,
			"33": 0.0109,
			"34": 0.07194,
			"35": 0.01526,
			"36": 0.00872,
			"37": 0.03924,
			"38": 0.01308,
			"39": 0.02616,
			"40": 0.10464,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": 0.00218,
			"10.6": 0.00436,
			"11.1": 0.00872,
			"11.5": null,
			"11.6": 0.02398,
			"12.1": 0.10682
		},
		"safari": {
			"0": null,
			"4": 0.01526,
			"5": 0.0218,
			"6": null,
			"7": 0.00654,
			"8": 0.00654,
			"9": 0.00654,
			"10": 0.04142,
			"3.1": 0.00654,
			"3.2": null,
			"5.1": 0.01962,
			"6.1": null,
			"7.1": 0.01308,
			"9.1": 0.05014
		},
		"ios_saf": {
			"8": 0,
			"10": 8.67077172356,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.233667264779,
			"8.1-8.4": 0.431690370525,
			"9.0-9.2": 0.205944029975,
			"9.3": 3.14196661116
		},
		"android": {
			"3": 0,
			"4": 0.33381498708,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.041726873385,
			"4.1": 1.20411834625,
			"4.2-4.3": 3.01029586563,
			"4.4": 6.90281705426,
			"4.4.3-4.4.4": 6.96242687339
		},
		"ie": {
			"6": 0.00228871883061,
			"7": 0.0228871883061,
			"8": 0.885734187446,
			"9": 0.460032484953,
			"10": 0.119013379192,
			"11": 1.16953532244,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0323572731437,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000898813142881
		},
		"edge": {
			"12": 0.00436,
			"13": 0.02398,
			"14": 0.0218
		},
		"ie_mob": {
			"10": 0.0786405633803,
			"11": 0.32017943662
		},
		"bb": {
			"7": 0.025415,
			"10": null
		},
		"samsung": {
			"0": 14.99876
		},
		"and_uc": {
			"0": 0.17204
		},
		"op_mini": {
			"0": 0.435943913713
		},
		"and_chr": {
			"0": 31.4331
		},
		"and_ff": {
			"0": 0.01564
		}
	},
	"total": 95.6779062812
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TM.json
 ** module id = 662
 ** module chunks = 0
 **/